import * as tealiumTrackingFunctions from './errorpageTealium';

const combindedTrackingFunctions = tealiumTrackingFunctions;

export default combindedTrackingFunctions;
